export default {
  en: {
    javascript: {
      dynatable: {
        pagination: {
          next: "Next",
          pages: "Pages: ",
          previous: "Previous",
          show: "Show"
        }
      },
      job_status: {
        complete: "The contracts for the investment have been successfully generated. ",
        creating_documents: "Generating contracts for the investment...",
        documents_generated: "Documents generated...",
        incomplete: "Something went wrong. Generation of the contracts failed.",
        loading: "Loading...",
        mostly_complete: "Generating contracts...",
        partly_complete: "First contract generated...",
        processing_documents: "Processing documents to be signed...",
        ready_for_signing: "Documents ready for signing."
      },
      share_ownerships: {
        form: {
          details: "OPTION DETAILS",
          numbers: "Number range",
          owner: {
            general: "HOLDER DETAILS",
            share: "SHAREHOLDER DETAILS"
          },
          quantity: "Quantity",
          series: "Series",
          share_details: "SHARE DETAILS",
          share_numbers: "Share number range",
          share_quantity: "Quantity",
          share_series: "Series"
        }
      },
      table: {
        download_csv: "Download CSV",
        find_from_table: "Find"
      }
    }
  },
  fi: {
    javascript: {
      dynatable: {
        pagination: {
          next: "Seuraava",
          pages: "Sivut: ",
          previous: "Edelt\xe4v\xe4",
          show: "N\xe4yt\xe4"
        }
      },
      job_status: {
        complete: "Sijoituksen sopimukset luotu onnistuneesti.",
        creating_documents: "Luodaan sijoitukselle sopimuksia...",
        documents_generated: "Sopimukset luotu...",
        incomplete: "Jokin meni pieleen. Sopimusten luonti ep\xe4onnistui.",
        loading: "Ladataan...",
        mostly_complete: "Luodaan sopimuksia...",
        partly_complete: "Ensimm\xe4inen sijoitussopimus luotu...",
        processing_documents: "Prosessoidaan allekirjoitettavia dokumentteja...",
        ready_for_signing: "Sopimukset valmiina allekirjoitettavaksi."
      },
      share_ownerships: {
        form: {
          details: "TIEDOT",
          numbers: "Numerot",
          owner: {
            general: "OMISTAJAN TIEDOT",
            share: "OSAKKEENOMISTAJAN TIEDOT"
          },
          quantity: "Lukum\xe4\xe4r\xe4",
          series: "Sarja",
          share_details: "OSAKETIEDOT",
          share_numbers: "Osakkeiden numerot",
          share_quantity: "Osakkeiden lukum\xe4\xe4r\xe4",
          share_series: "Osakesarja"
        }
      },
      table: {
        download_csv: "Lataa CSV",
        find_from_table: "Etsi taulukosta"
      }
    }
  }
};
